<template>
  <div>
    <vs-card>
      <b-row>
        <b-col style="margin-bottom: 30px">
          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Ad/Soyad"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>

            <b-col cols="7" align-self="center">
              <b-form-input
                id="adiSoyad"
                placeholder="Ad/Soyad"
                v-model="adiSoyad"
              />
            </b-col>
          </b-row>

          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Kullanıcı"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>

            <b-col cols="7" align-self="center">
              <b-form-input
                id="kullanici"
                placeholder="Kullanıcı"
                v-model="kullanici"
              />
            </b-col>
          </b-row>

          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Şifre"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>

            <b-col cols="7" align-self="center">
              <b-form-input id="pass" placeholder="Şifre" v-model="pass" />
            </b-col>
          </b-row>
        </b-col>
        <b-col style="margin-bottom: 30px">
          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Plasiyer"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>

            <b-col cols="7" align-self="center">
              <b-form-input
                id="plasyer"
                placeholder="Plasiyer"
                v-model="plasyer"
              />
            </b-col>
          </b-row>
          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Rol"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>

            <b-col cols="7" align-self="center">
              <v-select
                v-model="role"
                label="name"
                :options="roloption"
                placeholder="Rol"
              />
            </b-col>
          </b-row>

          <b-row style="margin: 10px">
            <b-col cols="5" align-self="center">
              <b-form-group
                label="Durum"
                label-for="h-first-name"
                style="font-size: 15px"
              >
              </b-form-group>
            </b-col>
            <b-col cols="7" align-self="center">
              <v-select
                v-model="durum"
                label="name"
                :options="durumoption"
                placeholder="Durum"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <div slot="footer">
        <vs-row vs-justify="flex-end">
          <vs-button
            style="border-radius: 5px"
            type="gradient"
            color="danger"
            icon="done"
            @click="kullaniciEkleGuncelle"
            >Kaydet</vs-button
          >
        </vs-row>
      </div>
    </vs-card>

    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import 'ag-grid-enterprise';
import KullaniciGuncelleButon from "../components/uzum-components/kullanici-components/KullaniciGuncelleButon.vue";
import KullaniciIslemleriDurumRender from "./CellRenderer/KullaniciIslemleriDurumRender.vue";
import KullaniciIslemleriRolRender from "./CellRenderer/KullaniciIslemleriRolRender.vue";
export default {
  data() {
    return {
      localeText: null,
      rowData: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      roloption: [],
      durumoption: [
        { name: "Aktif", value: "1" },
        { name: "Pasif", value: "0" },
      ],
      id: "",
      adiSoyad: "",
      kullanici: "",
      pass: "",
      plasyer: "",
      role: "",
      durum: "",
    };
  },
  components: {
    KullaniciIslemleriDurumRender,
    KullaniciIslemleriRolRender,
    "v-select": vSelect,
    AgGridVue,
    KullaniciGuncelleButon,
  },
  methods: {
    kullaniciGuncelleIslem(item) {
      this.id = item.id;
      this.adiSoyad = item.adSoyad;
      this.kullanici = item.kullaniciAdi;
      this.pass = item.sifre;
      this.plasyer = item.plasiyer;
      this.role = {
        name:
          item.rol == 1
            ? "Owner"
            : item.rol == 2
            ? "Admin"
            : item.rol == 3
            ? "User"
            : item.rol == 4
            ? "Paketleme"
            : "Tezgahtar",
        val: item.rol,
      };
      this.durum = {
        name: item.durum == 0 ? "Pasif" : "Aktif",
        value: item.durum,
      };
    },
    kullaniciEkleGuncelle() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var argsGuncelle = {
        token: Store.state.tokenId,
        id: "",
        adiSoyad: vm.adiSoyad,
        kullanici: vm.kullanici,
        pass: vm.pass,
        plasyer: vm.plasyer,
        role: vm.role.val,
        durum: vm.durum.value,
        islem: "1",
      };
      if (vm.id != "") {
        argsGuncelle = {
          token: Store.state.tokenId,
          id: vm.id,
          adiSoyad: vm.adiSoyad,
          kullanici: vm.kullanici,
          pass: vm.pass,
          plasyer: vm.plasyer,
          role: vm.role.val,
          durum: vm.durum.value,
          islem: "2",
        };
      }
      soap.createClient(url, function (err, client) {
        client.kullaniciEkleGuncelle(argsGuncelle, function (err, result) {
          if (result.kullaniciEkleGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(
            JSON.stringify(result.kullaniciEkleGuncelleResult)
          );
          vm.kullanciListe();
          vm.id = "";
          vm.adiSoyad = "";
          vm.kullanici = "";
          vm.pass = "";
          vm.plasyer = "";
          vm.role = "";
          vm.durum = "";
        });
      });
    },
    kullaniciRolListe() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.kullaniciRolListe(args, function (err, result) {
          if (result.kullaniciRolListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.kullaniciRolListeResult);

          const arrayFailed = Object.entries(vm.veriler).map((arr) => ({
            name: arr[0],
            val: arr[1],
          }));
          vm.roloption = arrayFailed;
        });
      });
    },
    kullanciListe() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.kullanciListe(args, function (err, result) {
          if (result.kullanciListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.kullanciListeResult);
          let list = vm.veriler.jsonData;
          vm.rowData = list;
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
  },
  created() {
    this.kullanciListe();
    this.kullaniciRolListe();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("setGuncellenecekKullanici", (item) => {
      this.kullaniciGuncelleIslem(item);
    });
  },
  beforeDestroy() {
    this.$root.$off("setGuncellenecekKullanici");
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "KullaniciGuncelleButon",
      },

      {
        headerName: "Kullanıcı Ad/Soyad",
        field: "adSoyad",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Kullanıcı Rol",
        cellRenderer: "KullaniciIslemleriRolRender",
        autoHeight: true,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Durum",
        field: "durum",
        filter: "agTextColumnFilter",
        cellRenderer: "KullaniciIslemleriDurumRender",
        autoHeight: true,
      },
    ];
  },
};
</script>